import { Link } from 'react-router-dom';
import type { DiscoveredPrototype } from '../../shared/discoverPrototypes';
import { STATUS_BADGE } from './constants';
import type { Status } from './constants';

interface RecentBarProps {
  prototypes: DiscoveredPrototype[];
  recentSlugs: string[];
  protoBasePath: string;
}

export default function RecentBar({ prototypes, recentSlugs, protoBasePath }: RecentBarProps) {
  const recents = recentSlugs
    .map((slug) => prototypes.find((p) => p.slug === slug))
    .filter((p): p is DiscoveredPrototype => p !== undefined)
    .slice(0, 5);

  if (recents.length === 0) return null;

  return (
    <div style={{
      background: '#f8fafc',
      borderBottom: '1px solid #e2e8f0',
      padding: '10px 24px',
      display: 'flex', alignItems: 'center', gap: 16,
      overflowX: 'auto',
    }}>
      <span style={{
        fontSize: 10, fontWeight: 700, color: '#64748b',
        textTransform: 'uppercase', letterSpacing: '0.6px', whiteSpace: 'nowrap',
      }}>
        Récents
      </span>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'nowrap' }}>
        {recents.map((proto) => {
          const badge = STATUS_BADGE[(proto.meta.status ?? 'draft') as Status];
          return (
            <Link key={proto.slug} to={`${protoBasePath}/${proto.slug}`} style={{
              display: 'inline-flex', alignItems: 'center', gap: 7,
              padding: '4px 12px', borderRadius: 20,
              background: 'white',
              border: '1px solid #e2e8f0',
              textDecoration: 'none', fontSize: 12, color: '#1e293b',
              fontWeight: 500, whiteSpace: 'nowrap',
              transition: 'background 0.12s, border-color 0.12s',
            }}
              onMouseEnter={(e) => { e.currentTarget.style.background = '#ede9fe'; e.currentTarget.style.borderColor = '#6366f1'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = 'white'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
            >
              <span style={{ width: 6, height: 6, borderRadius: '50%', background: badge.fg, flexShrink: 0 }} />
              {proto.meta.title}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
